// extracted by mini-css-extract-plugin
export default {"icon":"LR90ZL76FR","icon_raster":"qGq0_qdMSY","icon_colorizedSvg":"T2pl_QpyxQ"};